import * as React from 'react'
import {useSelector} from 'react-redux'

import Button from 'airship/patterns/button'
import Feedback from 'airship/patterns/feedback'

import {
  AIRSHIP_EU_SUPPORT_INSTANCE,
  AIRSHIP_SUPPORT_INSTANCE,
} from '../constants'
import {
  selectImageError,
  selectIsDGCP,
  selectSupportLevel,
  selectTicketNumber,
} from '../selectors'

interface ThankYouProps {
  // TODO : Delete props when the flag ADVSEG-6098 will be removed, they will not be used anymore
  handleClose?: () => void
}

const ThankYou: React.FC<ThankYouProps> = ({handleClose}) => {
  const ticketNumber = useSelector(selectTicketNumber)
  const supportLevel = useSelector(selectSupportLevel)
  const imageError = useSelector(selectImageError)
  const isDGCP = useSelector(selectIsDGCP)

  const airshipSupportInstance = isDGCP
    ? AIRSHIP_EU_SUPPORT_INSTANCE
    : AIRSHIP_SUPPORT_INSTANCE

  return (
    <>
      <h1 className="u-space-bottom-1">
        Thank you for contacting Airship Support
      </h1>
      <div className="u-space-bottom-1">
        <p>
          We appreciate your patience as our team reviews your issue{' '}
          <a
            className="u-blue"
            href={`${airshipSupportInstance}hc/requests/${ticketNumber}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            #{ticketNumber}
          </a>
          . Replies are sent to your account&apos;s email address.
        </p>
      </div>
      <p className="u-space-bottom-1">
        See our{' '}
        <a
          className="u-blue"
          href="https://www.airship.com/legal/support-services/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support Services page
        </a>{' '}
        for hours, response times, priorities, and coverage information.
        {supportLevel === 'unknown'
          ? ''
          : ` Your support level is ${supportLevel.toUpperCase()}.`}
      </p>
      {imageError ? (
        <Feedback type="warning">
          Sorry, we encountered a problem attaching your screenshot. Please add
          the file to your linked issue.
        </Feedback>
      ) : null}

      {handleClose && (
        <div className="u-flex u-flex-justify-end">
          <Button onClick={handleClose} style="navy">
            Close
          </Button>
        </div>
      )}
    </>
  )
}

export default ThankYou
